export const PollSliceTypes = {
    SHOW_POLL: "SHOW_POLL",
    SHOW_POLL_DETAILS: "SHOW_POLL_DETAILS",
    ADD_POLL: "ADD_POLL",
    UPDATE_POLL: "UPDATE_POLL",
    DELETE_POLL: "DELETE_POLL",
};
